import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Simulacao } from '../models/simulacao.model';
import { Proposta } from '../models/proposta.model';
import { decrypt } from '../helpers/crypt.helper';

@Injectable({
  providedIn: 'root'
})
export class CreditoService {

  constructor(private http: HttpClient) { }

  simulacao(): Promise<Simulacao> {
    return this.http.post<Simulacao>(`${environment.base_url}${environment.endpoints.simulacao}`, {}).toPromise();
  }

  proposta(payload: Proposta): Promise<any> {
    const xKeyI = JSON.parse(decrypt(sessionStorage.getItem(environment.localpoints.authResult))).xKeyI;
    // //@ts-ignore
    // let bodyCrypted = SemearDDC.crypto(payload, xKeyI);
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };
    console.log('final payload => ', payload);
    
    return this.http.post<Proposta>(`${environment.base_url}${environment.endpoints.proposta}`, payload, options).toPromise();
  }
}
